<template>
  <div id="lotto">
    <div class="rightContent">
      <div class="listBlock">
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
          <el-checkbox class="checkbox" v-for="(city,i) in lists" :label="city.lotto_code" :key="i">{{city.lotto_code}}-{{city.lotto_name}} ({{city.cate_name}})</el-checkbox>
        </el-checkbox-group>
        <el-button @click="saveKeep" type="primary" style="margin-top:20px">保存</el-button>
        <div class="tips">
          注：以上选中状态即为收藏夹初始默认收藏内容
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "lotto",
  data() {
    return {
      doing: false,
      doing2: false,
      lists: [],
      cate: "",
      checkAll: false,
      checkedCities: ['10029','10005','10050','10027','10035','10048','10011','10014','10028','10051'],
      cityOptions: ['10029','10005','10050','10027','10035','10048','10011','10014','10028','10051'],
      isIndeterminate: true
    };
  },
  computed: {},
  created() {
    this.resizedwindow();
    this.getList();
    this.getKeep();
  },
  methods: {
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.lists.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.lists.length;
    },
    getList() {
      if (this.doing2 === true) {
        return false;
      }
      let dataLoadIng = this.openFullScreen();
      this.doing2 = true;
      let _this = this;
      let data = {
        cate_id: this.cate
      };
      this.axios
        .post("/kaiSrv/mgr/lottoList", this.formData(data))
        .then(function(response) {
          _this.doing2 = false;
          if (response.data.code == 0) {
            _this.lists = response.data.list;
          }
          setTimeout(() => {
            dataLoadIng.close();
          }, 500);
        });
    },
    saveKeep(){
      if (this.doing === true) {
        return false;
      }
      this.doing = true;
      let _this = this;
      let data = {
        keep: this.checkedCities
      };
      this.axios
        .post("/kaiSrv/mgr/saveKeep", this.formData(data))
        .then(function(response) {
          _this.doing = false
          _this.getKeep()
          alert('保存成功过')
        })
    },
    getKeep(){
      if (this.doing === true) {
        return false;
      }
      this.doing = true;
      let _this = this;
      let data = {};
      this.axios
        .post("/kaiSrv/mgr/getKeep", this.formData(data))
        .then(function(response) {
          _this.doing = false
          _this.checkedCities = response.data.keep
        })
    }
  }
};
</script>
<style  lang="scss">
#lotto {
  .tabs-container {
    .el-card__header {
      padding: 0.0833rem 0.1667rem !important;
    }
    .el-card {
      cursor: pointer;
    }
    .el-card:hover {
      border: $blue 1px solid;
    }
  }
  .el-input__inner {
    width: 2.5rem;
  }
  .codeshearch,
  .codeshearch .el-input__inner {
    width: 1.5rem;
  }
  .el-pagination .el-input__inner {
    width: 0.9rem;
  }
  .codeshearch {
    margin-left: 0.05rem;
    margin-right: 0.02rem;
  }
  .avatar-uploader,
  .el-upload,
  .el-upload--text {
    width: 1.22rem;
    height: 1.2rem;
    display: inline-block;
  }
  .avatar-uploader-icon {
    border: 1px solid #ccc;
  }
  .checkbox{
    width: 20%;
    margin-top: 10px;
  }
}
</style>
<style scoped lang="scss">
#lotto {
  box-sizing: border-box;
  .rightContent {
    width: calc(100% - 0.32rem);
    height: calc(100% - 0.1667rem);
    display: inline-block;
    background-color: #fff;
    margin-left: 0.1667rem;
    margin-top: 0.1667rem;
    border-radius: 0.05rem;
    .tableheader {
      margin: 0.16rem;
    }
    p.title {
      height: 0.4167rem;
      line-height: 0.4167rem;
      font-size: 0.15rem;
      color: #000;
    }
    .btn2,
    .btn3 {
      padding: 0.0667rem 0.0833rem;
      background-color: #409eff;
      border: 1px solid #409eff;
    }
    .listBlock {
      margin: 0.08rem;
    }
    .warncolor {
      color: red;
    }
    .btndel {
      margin-left: 0.1rem;
      height: 0.28rem;
      position: relative;
      top: 0.05rem;
    }
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 1.22rem;
    height: 0.5rem;
    margin-left: 1rem;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    color: #8c939d;
    width: 1.22rem;
    height: 1.22rem;
    text-align: center;
    line-height: 1.22rem;
    margin-top: 0.08rem;
  }
  .imgblockForLogo {
    width: 1.22rem;
    height: 1.22rem;
    display: inline-block;
    border: 1px solid #ccc;
    margin-top: 0.08rem;
  }
  .avatar {
    width: 1.22rem;
    height: 1.22rem;
    display: block;
  }
  .tips{
    font-size: 16px;
    color: red;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/keep.vue